















import {
	defineComponent,
	Ref,
	ref,
	watch,
	PropType,
	computed,
} from '@vue/composition-api';
import { getGroupEvents } from '@front-app/services/GroupsApi/GroupsEventsApi';
import { EventV2 } from '@front-app/services/EventsApi/EventModel';
import SortedFilteredEventList from '@front-app/components/event/SortedFilteredEventList.vue';
import { sleep } from '@front-app/util/async';
import deepEqual from 'deep-equal';
import { trackGroupSimpleAction } from '@front-app/services/ActionApi/ActionApi';
import { GroupAuditAction } from '@front-app/services/ActionApi/ActionModel';
import { BannerLocation } from '@front-app/services/ActionApi/UserActionRequestModel';
import { convertGroupEventRole } from '@front-app/modules/groupMember/util/role';
import { DEFAULT_EVENT_FILTERS, EventFilter } from '../events/EventEnum';

const HEADER_OFFSET_ELEMENTS = [
	'.page-header__wrapper',
	'.header-wrapper',
];

export default defineComponent({
	components: {
		SortedFilteredEventList,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		currentAccessFilters: {
			type: Array as PropType<EventFilter[]>,
			default: DEFAULT_EVENT_FILTERS,
		},
		currentTypeFilters: {
			type: Array as PropType<string[]>,
			default: () => [],
		},
		currentTopicFilters: {
			type: Array as PropType<string[]>,
			default: () => [],
		},
	},
	setup(props) {
		// Init events
		const areEventsLoading = ref(false);
		const requestScroll = ref(false);
		const events: Ref<EventV2[]> = ref([]);
		const getGroupsEvents = async (curr: string, prev?: string) => {
			if (curr === prev || !curr) {
				return;
			}
			areEventsLoading.value = true;
			const result = await getGroupEvents(curr);
			events.value = result.map(convertGroupEventRole);
			areEventsLoading.value = false;
			// This is a shitty hack to get the pack to scroll again in the case that the group
			// header needs to be caused to collapse
			await sleep(500);
			requestScroll.value = !requestScroll.value;
		};
		watch(() => props.groupId, getGroupsEvents, { immediate: true });

		const trackActionProps = computed(() => props.groupId);
		watch(trackActionProps, (curr, prev) => {
			if (deepEqual(curr, prev) && props.groupId) {
				return;
			}
			trackGroupSimpleAction(props.groupId, GroupAuditAction.VIEW_EVENTS_LIST_PAGE);
		}, { immediate: true });

		return {
			events,
			areEventsLoading,
			requestScroll,
			BannerLocation,
			HEADER_OFFSET_ELEMENTS,
		};
	},
});
